import React from "react";

export default function ActiveInactiveToggle({ checked, disabled, onChange, labelId }) {
  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        aria-labelledby={labelId}
        disabled={disabled}
        onClick={(e) => {
          e.stopPropagation();
          onChange(!checked);
        }}
        className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors ${
          checked ? "bg-green-600" : "bg-gray-300 dark:bg-gray-600"
        } ${disabled ? "cursor-wait opacity-50" : "cursor-pointer"}`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-sm transition-transform ${
            checked ? "translate-x-4" : "translate-x-0.5"
          }`}
        />
      </button>
      <span
        id={labelId}
        className={`text-xs font-semibold whitespace-nowrap ${
          checked ? "text-green-700 dark:text-green-400" : "text-gray-500 dark:text-gray-400"
        }`}
      >
        {checked ? "Active" : "Inactive"}
      </span>
    </div>
  );
}
